/**
 * Centralized ID Generation Utilities
 * Provides consistent ID generation across the application
 */

/**
 * Generates a 5-character base36 string for compact IDs
 */
const generateBase36Id = (): string => {
  return Math.random().toString(36).substring(2, 7)
}

/**
 * Generates a new block ID in the required format
 * Format: 5-character base36 string (e.g., "a3f9k")
 */
export const generateBlockId = (): string => {
  return generateBase36Id()
}

/**
 * Generates a new encryption ID in the required format
 * Format: "enc_" + 5-character base36 string (e.g., "enc_x7k2p")
 */
export const generateEncryptionId = (): string => {
  return `enc_${generateBase36Id()}`
}

